import TableCell from "./TableCell.jsx";

const TableDragHandleCell = ({ children, className = '', ...props }) => {
  const classes = ['common-table__drag-handle', className].filter(Boolean).join(' ');

  return (
    <TableCell className={classes} {...props}>
      {children}
    </TableCell>
  );
};

export default TableDragHandleCell;
